var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-app-bar',{attrs:{"color":"blue-grey darken-1","dense":"","dark":""}},[_c('v-app-bar-nav-icon'),_c('v-toolbar-title',[_vm._v("統一企業集團特約商店")]),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }